interface ReadReceiptMessage {
  id: string
  author: { id: string }
  /** ISO timestamp of when the message was created. */
  createdAt: string
}

/**
 * Read receipt: the id of the most recent message *I* sent that the other
 * person has already read (their last-read time is at or after it). Only that
 * one message shows "Vu", WhatsApp-style.
 *
 * Returns `undefined` when there is no data, no current user, no read time, or
 * none of my sent messages were read yet.
 */
export function computeLastReadSentMessageId<T extends ReadReceiptMessage>(
  messages: T[] | null | undefined,
  currentUserAccountId: string | null | undefined,
  othersLastReadAt: string | null | undefined,
): string | undefined {
  if (!messages || !currentUserAccountId || !othersLastReadAt) return undefined

  const readAtMs = new Date(othersLastReadAt).getTime()

  const readSent = messages
    .filter(
      (m) => m.author.id === currentUserAccountId && new Date(m.createdAt).getTime() <= readAtMs,
    )
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())

  return readSent[0]?.id
}
